<div class="page-container">
    <div class="row center-xs">
        <div class="col-xs-12 col-sm-11 col-md-9">
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h1>BOTON WEB</h1>
                            <div class="text-content-bigger">El comercio puede conectarse con nuestra librería web en
                                menos de 2 horas.
                                La librería web es full javascript, permitiendo la integración de cualquier tienda web
                                en cualquier lenguaje de programación.
                            </div>
                            <div class="text-content-bigger">El formulario de pago se crea dinámicamente, haciendo
                                segura la captura y el envío de los datos de tarjeta.
                                El comercio decide cómo y dónde mostrar el formulario de pago, permitiendo continuar con
                                la experiencia del cliente en la tienda web.
                            </div>
                            <!-- <div class="text-content-bigger">El pago es solicitado al procesador de pagos y la respuesta
                                es mostrada al cliente sin errores y sin demoras.
                                El comercio recibe la notificación de autorización de los servidores de epago.
                            </div> -->
                            <!-- <div class="text-content-bigger">Descarga un ejemplo de integración completo al botón de
                                pago web, <a href="https://github.com/synapsolutions/shop-web">visita nuestro link en
                                    git.</a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="img-container">
                        <img class="img" src="assets/img/web-agoraweb-button-form.png">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h2>Instalación</h2>
                            <div class="text-content">La librería web es full javascript, permitiendo la integración de
                                cualquier tienda web en cualquier lenguaje de programación.
                            </div>
                            <div class="text-content">1. Importar libreria en la web
                            </div>
                            <div class="code-content-xs">
                                <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
                                    style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="57ba6cb170135dfb487ba87bff0f05b8"
                                    fileName="epago-web-head-script.html"></ng-gist>
                            </div>
                        </div>
                        <div class="paragraph">
                            <h2>Configuración</h2>

                            <div class="tab-wrap">
                                <input type="radio" name="tabs" id="tab1" checked>
                                <div class="tab-label-content" id="tab1-content">
                                    <label for="tab1">Pago con Formulario</label>
                                    <div class="tab-content"><app-web-agoraweb-form-button></app-web-agoraweb-form-button></div>
                                </div>
                                <input type="radio" name="tabs" id="tab2">
                                <div class="tab-label-content" id="tab2-content">
                                    <label for="tab2">Pago sin Formulario</label>
                                    <div class="tab-content"><app-web-agoraweb-noform-button></app-web-agoraweb-noform-button></div>
                                </div>
                                <div class="slide"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>